/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description payloadKeyReducer(key) - creates a reducer that returns `action.payload[key]`
 */

import { Action } from 'redux-actions'

type PayloadKeyReducer = <
  State,
  Key extends string,
  Payload extends { [P in Key]?: State | undefined },
>(
  key: Key
) => (
  state: State,
  action: Action<string, Payload>
) => Exclude<Payload[Key], undefined> | State

export const payloadKeyReducer: PayloadKeyReducer =
  (key) => (state, action) => {
    if (action?.payload) {
      const value = action.payload[key]
      if (typeof value !== 'undefined') {
        return value!
      }
    }
    return state
  }
